import { useOutletContext } from 'react-router-dom'
import { Treinamento } from 'service/api'

export function useTreinamentosOutletContext() {
    return useOutletContext<{ data: Treinamento[]; clienteId: number }>()
}
